import { landingPageApi } from '@Features/LandingPage/LandingPageApi/LandingPageApi'
export default landingPageApi
